import axiosHttp from "services/axiosHttp";
import { REWARD_BASE_URL } from "configs/AppConfig";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchTerminalList = createAsyncThunk(
  "fetchTerminalList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.get(
        `${REWARD_BASE_URL}pos-terminal`
      );
      return response.data.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const TerminalListSlice = createSlice({
  name: "TerminalListSlice",
  initialState: {
    isLoading: false,
    isError: false,
    error: null,
    data: null,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTerminalList.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(fetchTerminalList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.data = action.payload;
    });
    builder.addCase(fetchTerminalList.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    });
  },
});
export default TerminalListSlice.reducer;